import { render, staticRenderFns } from "./JcdcDateRanges.vue?vue&type=template&id=940fc080"
import script from "./JcdcDateRanges.vue?vue&type=script&lang=ts"
export * from "./JcdcDateRanges.vue?vue&type=script&lang=ts"
import style0 from "./JcdcDateRanges.vue?vue&type=style&index=0&id=940fc080&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports